<template>
    <b-modal ref="modal" :id="`hosekit-modal-${productId}`" centered scrollable no-fade hide-footer>
        <div class="hose">
            <div :key="sectionIndex" v-for="(section, sectionIndex) in options" :class="`section-${ sectionIndex.toLowerCase() }`">
                <div class="row mt-3">
                    <div class="col-md-3">
                        <div v-if="section['2-foot'].length > 0">
                            <span><strong>2-foot</strong></span>
                            <div class="mt-3">
                                <button @click="onProductSelect(sectionIndex, typeIndex, product)" :key="typeIndex" v-for="(product, typeIndex) in section['2-foot']" class="btn btn-light">
                                    {{ product.description }} <small>{{ product.serial }}</small>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div v-if="section['3-foot'].length > 0">
                            <span><strong>3-foot</strong></span>
                            <div class="mt-3">
                                <button @click="onProductSelect(sectionIndex, typeIndex, product)" :key="typeIndex" v-for="(product, typeIndex) in section['3-foot']" class="btn btn-light">
                                    {{ product.description }} <small>{{ product.serial }}</small>
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-6" v-if="sectionIndex == 'A'">
                        <img src="../../public/Automatic.png" class="img-fluid mb-3">
                    </div>

                    <div class="col-md-6" v-if="sectionIndex == 'B'">
                        <img src="../../public/Manual.png" class="img-fluid mb-3">
                    </div>
                </div>

                <div><small>{{ section.description }}</small></div>
            </div>
        </div>
    </b-modal>
</template>

<script>
    export default {
        props: ['productId', 'options'],
        methods: {
            onProductSelect (section, type, product) {
                this.$emit('result', {
                    id: this.productId,
                    section,
                    type,
                    product
                })

                this.$refs.modal.hide()
            }
        }
    }
</script>

<style scoped>
    div.section-a {
        background-color: #43a355
    }

    div.section-b {
        background-color: #6c757d
    }

    div.section-c {
        background-color: #ffc107
    }
    .hose {
        margin-top:15px;
        color:#fff;
    }
    /*.hose button {
    display: block;
    width:100%;
    padding: 4px 12px;
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 20px;
    color: #333333;
    text-align: center;
    text-shadow: 0 1px 1px rgba(255, 255, 255, 0.75);
    cursor: pointer;
    background-color: #f5f5f5;
    background-image: -moz-linear-gradient(top, #ffffff, #e6e6e6);
    background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#ffffff), to(#e6e6e6));
    background-image: -webkit-linear-gradient(top, #ffffff, #e6e6e6);
    background-image: -o-linear-gradient(top, #ffffff, #e6e6e6);
    background-image: linear-gradient(to bottom, #ffffff, #e6e6e6);
    background-repeat: repeat-x;
    border: 1px solid #cccccc;
    border-color: #e6e6e6 #e6e6e6 #bfbfbf;
    border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
    border-bottom-color: #b3b3b3;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff', endColorstr='#ffe6e6e6', GradientType=0);
    filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);
    -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);
    -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);        
}
.hose button:hover {
    background: #e6e6e6;
}
.hose button:focus {
    background: #e6e6e6;
    background-image: none;
    outline: 0;
    -webkit-box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.05);
    -moz-box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.05);
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.05);
}   */
.hose .btn-light {
    display:block;
    width:100%;
    margin-bottom:10px;
    background-color: #fff;
    border-color: #fff;
    -moz-box-shadow: inset 0 0 10px rgba(0,0,0,0.1);
    -webkit-box-shadow: inset 0 0 10px rgba(0,0,0,0.1);
    box-shadow: inset 0 0 10px rgba(0,0,0,0.1);
}
.hose .btn-light:hover, .btn-light:focus {
    background-color:#E2E6EA;
    border-color:#E2E6EA;
}
.hose button small {
    display:block;
}
.section-a, .section-b, .section-c {
    display:block;
    padding:20px;
}
</style>
